function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M0 85.333h512V426.67H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M11.13 96.464h489.739V415.54H11.13z"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  fill: "#d80027"
}, /*#__PURE__*/React.createElement("path", {
  d: "M131.2 255.996L256 177.554l124.8 78.442L256 334.439z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M250.435 85.33v165.101H0v11.13h250.435v165.101h11.13V261.561H512v-11.13H261.565V85.33z"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M152.116 255.996L256 190.702l103.884 65.294L256 321.292z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#6da544",
  d: "M325.02 277.901l-12.366 7.78H196.641l.646-1.291 14.191-28.394 14.837 14.837H256l14.837-22.261 14.848 7.424 14.837-14.837z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "M256 211.474l3.684 11.338h11.92l-9.644 7.005 3.685 11.339-9.645-7.008-9.645 7.008 3.685-11.339-9.644-7.005h11.92z"
});

const SvgSintEustatius = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSintEustatius, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sint-eustatius.c0e36adf.svg";
export { ForwardRef as ReactComponent };